import React from "react";
import { Switch } from "react-router-dom";
import PrivateRoute from "../../Layout/PrivateRoute";
import MyApp from "../../Client/MyApp/index";
import { RoutesUrl } from "../constents";

const ClientRoutes = () => {
  return (
    <>
      <PrivateRoute exact path={RoutesUrl.MyApps} component={MyApp} />
    </>
  );
};

export default ClientRoutes;
